// src/shared/supabase/functions/searchCars.ts
import supabase from "../../../shared/database/supabase";
import { CarWithCostumer } from "../model/car";

export interface ListCarsRequest {
  plate: string;
  chassi: string;
  limit: number;
  offset: number;
  costumerId: string;
}

export interface ListCarsResponse {
  cars: Array<CarWithCostumer>;
  total: number;
}

export const listCars = async (req: ListCarsRequest) => {
  try {
    const { data, error } = await supabase.functions.invoke<ListCarsResponse>("list-cars", {
      body: JSON.stringify({
        plate: req.plate,
        chassisNumber: req.chassi,
        limit: req.limit,
        offset: req.offset,
        costumerId: req.costumerId || null
      })
    });

    if (error) {
      console.error("Error calling list-cars:", error);
      return { cars: [], total: 0, error };
    }

    const cars =
      data?.cars.map((car: CarWithCostumer) => ({
        id: car.id,
        plate: car.plate,
        brand: car.brand,
        model: car.model,
        color: car.color,
        insurance_name: car.insurance_name,
        chassis_number: car.chassis_number,
        mileage: car.mileage ?? null,
        costumer: car.costumer,
        created_at: car.created_at
      })) || [];

    return {
      cars: cars,
      total: data?.total ?? 0,
      error: null
    };
  } catch (err) {
    console.error("Exception in listCars:", err);
    throw err;
  }
};
